module.exports = __webpack_public_path__ + "assets/icons/ic_calibrated_badge_24px.svg";